import React, { useEffect, useState } from 'react'
import { Flex, Space ,Table} from 'antd'
import { useIncomeExpenditureListQuery } from '../../store/ReactWebSiteApi'
import BalanceAdd from './BalanceAdd'
import BalanceEdit from './BalanceEdit'
import BalanceDel from './BalanceDel'
import BalanceAudit from './BalanceAudit'
import ArapCheck from '../arap/ArapCheck'
import FundCheck from '../fund/FundCheck'
import Main from '../../cpn/Main'
import LedgerCheck from '../ledger/LedgerCheck'
import {DeleteOutlined,LogoutOutlined} from '@ant-design/icons';
import BalanceQuery from './BalanceQuery'
import BalanceCheck from './BalanceCheck'
import BalanceAuditTag from './BalanceAuditTag'
function BalanceList(props) {
    //判断权限：是否不能查看别人的收支
    let limit 
    if(localStorage.getItem('ess_menu_id').includes('75')){
         limit = localStorage.getItem('eu_id')
     }else{
         limit = ''
    }
    const [query,setQuery] = useState({
        eie_e_id:localStorage.getItem('e_id'),
        eie_state:'2',
        action:'search',
        eie_client_id:'',
        eie_uid:limit,
        eie_content:''
    })
    const {data,isSuccess} = useIncomeExpenditureListQuery(query,{refetchOnMountOrArgChange:1})    
    const [list, setList] = useState();    
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                const newArr = data.Result.map(item => {
                    const {eie_id:key,eie_type_id,eie_arrive_year,eie_egg_value,eie_arrive_month,eie_arrive_day,eie_finance_sub_type_name,eie_hx_ctime,ed_name,eie_jbr_uname,eie_audit1_ctime,eie_audit1_uname,eie_audit2_ctime,eie_audit3_ctime,eie_audit3_uname,eie_audit4_uname,eie_audit4_ctime,eie_audit2_uname,eie_hx_year,eie_hx_month,eie_hx_day,eie_amount,ec_name,eie_ebn_id,eie_content,eie_uname,eie_ctime,eie_update_ctime,eie_update_uname,eie_price,eie_image_file,eie_count,eci_name,eg_name,eu_name,eie_hx_number,eie_bank_log_id,eie_yw_name,ebn_team_num,eie_bank_ctime,eie_state} = item;
                    let type = ''
                        switch (eie_type_id) {
                            case '1'://销售收入
                            type = '团队收入'
                                break;
                            case '2'://成本支出
                            type = '团队支出'
                                break;
                            case '3'://费用支出
                            type = '费用支出'
                                break;
                            case '4'://其他收入
                            type = '其他收入'
                                break;
                            case '5'://其他支出
                            type = '其他支出'
                                break;              
                            default:
                                break;
                        }
                    return item = {key,eie_type_id,eie_arrive_year,eie_egg_value,eie_arrive_month,eie_arrive_day,eie_finance_sub_type_name,eie_hx_ctime,ed_name,eie_jbr_uname, eie_audit1_ctime,eie_audit1_uname,eie_audit2_ctime,eie_audit3_ctime,eie_audit4_ctime,eie_audit3_uname,eie_audit4_uname,eie_audit2_uname,eie_hx_year,eie_hx_month,eie_hx_day,eie_amount,ec_name,eie_ebn_id,eie_content,eie_uname,eie_ctime,eie_update_ctime,eie_update_uname,eie_price,eie_image_file,eie_count,eci_name,eg_name,eu_name,eie_hx_number,eie_bank_log_id,eie_yw_name,type,ebn_team_num,eie_bank_ctime,eie_state}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.eie_ctime;
                    let bTimeString = b.eie_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
                
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    const columns = [
        {
            key: 'id',
            title: '编号',
            dataIndex: 'key',   
            render:(_,record) => {
                return <BalanceCheck eie_id={record.key} titleType='数字' />
            }
        },        
        {
            key: 'eie_finance_sub_type_name',
            title: '类型',
            dataIndex: 'eie_finance_sub_type_name',
            render:(text,record) => {
                return record.type + ' - ' + text
            }
        },  
        {
            key: 'ebn_team_num',
            title: '团队编号',
            dataIndex: 'ebn_team_num',
            render:(text,record) => {
                return  <LedgerCheck 
                            titleType='数字'
                            ebn_id={record.eie_ebn_id} 
                            ebn_dept_id={record.ebn_dept_id}
                            ebn_team_num={record.ebn_team_num}
                        />
            }
        },  
        {
            key: 'client',
            title: '客户',
            dataIndex: 'ec_name',
        },                           
        {
            key: 'eie_amount',
            title: '金额',
            dataIndex: 'eie_amount',
            render:(text) => {
                if(text<0){
                    return <span style={{color:'green',fontSize:"16px"}}>{text}</span>
                }else{
                    return <span style={{color:'red',fontSize:"16px"}}>{text}</span>
                }
            }
        },                      
        {
            key: 'eie_content',
            title: '备注',
            dataIndex: 'eie_content',
        },  
        {
            key: 'eie_yw_name',
            title: '销售员',
            dataIndex:'eie_yw_name',
        },             
                                                 
        {
            key: 'ed_name',
            title: '部门',
            dataIndex: 'ed_name'
        },                                          
                                                
        {
            key: 'status',
            title: '审核',
            width:'6%',
            render:(_,record) => {
                return<>
                    <BalanceAuditTag
                        eie_audit1_uname={record.eie_audit1_uname}
                        eie_audit2_uname={record.eie_audit2_uname}
                        eie_audit3_uname={record.eie_audit3_uname}
                        eie_audit4_uname={record.eie_audit4_uname}
                        eie_audit1_ctime={record.eie_audit1_ctime}
                        eie_audit2_ctime={record.eie_audit2_ctime}
                        eie_audit3_ctime={record.eie_audit3_ctime}
                        eie_audit4_ctime={record.eie_audit4_ctime}
                        direction='vertical'
                    />
                </>
            }
        },             
        {
            key: 'hx',
            title: '下账转账',
            render:(_,record) => {
                return<>
                    {!record.eie_hx_ctime && <>待下账</>}
                    {(record.eie_hx_ctime && !record.eie_bank_ctime) && <ArapCheck eie_hx_number={record.eie_hx_number} eie_hx_ctime={record.eie_hx_ctime}/>}
                    {record.eie_bank_ctime && <FundCheck ecal_id={record.eie_bank_log_id} eie_bank_ctime={record.eie_bank_ctime}/>}
                </>
            },
            width:'6%'
        },            
             
        // {
        //     key: 'time',
        //     title: '操作记录',
        //     render: (_,record) => {
        //         return <>
        //             <div>新建时间：{record.eie_ctime + record.eie_uname}</div>
        //             <div>修改时间：{record.eie_update_ctime + record.eie_update_uname}</div>
        //         </>
        //     }
        // },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                     <Space>
                        <BalanceCheck
                            eie_id={record.key}
                            title={props.main_type_name}
                            jbr_label={props.jbr_label}
                            eie_jbr_uname={props.eie_jbr_uname} 
                            eie_esv_id={props.eie_esv_id}
                            eie_jbr_uid={props.eie_jbr_uid}
                            eie_type_id={record.eie_type_id}
                            eie_finance_sub_type_id={record.eie_finance_sub_type_id}
                            eie_finance_sub_type_name={record.eie_finance_sub_type_name}
                            eie_ebn_id={props.eie_ebn_id}
                            eie_eg_id={props.ebn_eg_id}
                            guige={props.guige}
                        />
                        <BalanceEdit 
                            eie_id={record.key}                            
                            eie_audit1_ctime={record.eie_audit1_ctime}
                            eie_hx_ctime={record.eie_hx_ctime}
                            efst_finance_type_id={props.main_type_id}
                            main_type_name={props.main_type_name}
                            eie_state={record.eie_state}
                            eie_type_id={record.eie_type_id}
                        />
                        <BalanceDel 
                            eie_audit1_ctime={record.eie_audit1_ctime}
                            eie_hx_ctime={record.eie_hx_ctime}
                            eie_id={record.key}
                            eie_state={record.eie_state}
                            eie_type_id={record.eie_type_id}
                        />
                        <BalanceAudit
                            eie_audit1_ctime={record.eie_audit1_ctime}
                            eie_audit2_ctime={record.eie_audit2_ctime}
                            eie_audit3_ctime={record.eie_audit3_ctime}
                            eie_audit4_ctime={record.eie_audit4_ctime}
                            eie_id={record.key}
                            eie_state={record.eie_state}
                            eie_type_id={record.eie_type_id}
                        />
                    </Space>
                </>
            }
        },
    ]
    return (
        <Main t1='收支' >
            {query.eie_state==='2' ? <Flex justify='space-between' align='center'>
                    <Space>
                        <BalanceAdd 
                            efst_finance_type_id={props.main_type_id}
                            main_type_name={props.main_type_name}
                        />
                        <BalanceQuery
                            getBalanceQuery={(e) => {
                                //判断权限：是否不能查看别人的收支
                                let limit2 
                                if(localStorage.getItem('ess_menu_id').includes('75')){
                                    limit2 = localStorage.getItem('eu_id')
                                }else{
                                    limit2 = ''
                                }
                                setQuery(prevState=>({
                                    ...prevState,
                                    eie_client_id:e.eie_client_id,
                                    eie_dept_id:e.eie_dept_id,
                                    eie_type_id:e.eie_type_id,
                                    eie_finance_sub_type_id:e.eie_finance_sub_type_id,
                                    eie_uid:limit2,
                                    eie_content:e.eie_content,
                                }))
                            }}
                        />
                    </Space>
                    <a 
                        style={{
                            marginRight:"20px",
                            fontSize:"18px"
                        }}
                        onClick={() => {
                            setQuery(prevState=>({...prevState,eie_state:'1'}))
                        }}
                    ><DeleteOutlined /> 已删除收支</a>
                </Flex>:<Flex>
                            <a 
                                style={{
                                    fontSize:"18px"
                                    }}
                                onClick={() => {
                                    setQuery(prevState=>({...prevState,eie_state:'2'}))
                                }}
                            ><LogoutOutlined /> 未删除收支</a>
                        </Flex>}
                <Table 
                    columns={columns} 
                    dataSource={list}  
                    style={{marginTop:"20px"}}   
                    pagination={{
                        pageSize:20,
                        showSizeChanger:true,
                        showTotal:(total) => `共${total}条`,
                    }}            
                />
        </Main>
    )
}

export default BalanceList